<script setup lang="ts">
import { MediaImageFragment, NewsFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'

const props = defineProps<{
  entity: NewsFieldsFragment
  breadcrumbs?: Link[]
}>()

const image = computed(() => {
  return props.entity?.fieldTeaserImage?.entity
    ? {
        small: props.entity?.fieldTeaserImage?.entity as MediaImageFragment,
      }
    : undefined
})

const title = computed(() => props.entity.title ?? '')
const subtitle = computed(() => props.entity.fieldNewsType?.entity?.name ?? '')
</script>

<template>
  <Hero
    class="section-hero-news"
    :content="{
      title,
      subtitle,
    }"
    :image="image"
    :breadcrumbs="breadcrumbs"
  />
</template>
<style scoped lang="scss">
.section-hero-news.hero {
  grid-template-rows: auto 1fr;
  @include breakpoint(ds) {
    grid-template-rows: auto;
  }
  :deep(.background) {
    grid-row: 2;
    width: 100%;
    display: grid;
    background-color: var(--c-background-medium);

    @include breakpoint(ds) {
      grid-column: 1 / -1;
      grid-row: 1;
    }
  }
  :deep(.content) {
    grid-column: 1 / -1;
    grid-row: 1;
    margin-top: 0;
    padding: 30px 24px 40px;
    display: grid;
    align-content: start;
    background-color: var(--c-background-medium);

    @include breakpoint(t) {
      grid-template-columns: repeat(12, minmax(0, 1fr));
      padding-inline: 0;
      padding-block: 64px;
      > .breadcrumbs,
      > .title {
        grid-column-end: 12;
      }
    }
    @include breakpoint(tl) {
      padding-inline: 32px;
      > .breadcrumbs,
      > .title {
        grid-column-end: 13;
      }
    }
    @include breakpoint(ds) {
      margin-top: 64px;
      padding-inline: 0;

      padding-block: 0 64px;
      background-color: transparent;

      > .breadcrumbs,
      > .title {
        grid-column-end: 11;
      }
    }

    .title {
      line-height: 115%;
      font-weight: bold;
      letter-spacing: 0;
      @include fluid-ts-ds(font-size, 30px, 44px);
    }
  }

  &.hero-image {
    :deep(.image) {
      width: 100%;
      height: auto;
      aspect-ratio: 1;
      justify-self: end;
      @include breakpoint(ds) {
        width: auto;
        height: 680px;
      }
    }
    :deep(.content) {
      @include breakpoint(ds) {
        margin-top: 0;
        padding: 160px 0 0;

        > .breadcrumbs,
        > .title {
          grid-column-end: 6;
        }
      }
    }
  }
}
</style>
